import { reactive } from 'vue'

const foldFuncMap = reactive<Map<string, (bol: boolean) => void>>(new Map())

export const setFoldFunc = (id: string, func: (bol: boolean) => void) => {
  foldFuncMap.set(id, func)
}

export const getFoldFunc = (id: string) => {
  return foldFuncMap.get(id)
}
export const removeFoldFunc = (id: string) => {
  foldFuncMap.delete(id)
}
